/**
 * PatientPhotoUpload — circular patient-photo control. Thin wrapper over the
 * shared `ImageUploadField` (dialog-based view / change / remove), matching
 * Flutter `personal_details_form.dart` photo block + `upload_image_dialog.dart`.
 */

import { ImageUploadField } from './image-upload-field';

export interface PatientPhotoUploadProps {
  url: string | null;
  onChange: (next: string | null) => void;
  /** Name for accessibility — read by screen readers on the photo button. */
  patientName?: string;
  disabled?: boolean;
}

export function PatientPhotoUpload({
  url,
  onChange,
  patientName,
  disabled = false,
}: PatientPhotoUploadProps) {
  return (
    <ImageUploadField
      url={url}
      onChange={onChange}
      disabled={disabled}
      variant="photo"
      dialogTitle="Change patient photo"
      emptyText="Photo"
      altText={`Patient photo${patientName ? ` of ${patientName}` : ''}`}
      allowRemove
    />
  );
}
